import axios from 'axios';
import { baseURL } from './types';
import {
  PATIENT_PROFILE_CREATED,
  GET_ONE_PATIENT_PROFILE,
  PATIENT_PROFILE_UPDATED,
  GET_ALL_PATIENT_PROFILES_SUCCESS,
  GET_ALL_PATIENT_PROFILES_FAIL,
} from './types';

// 🔐 Auth Headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Create Patient Profile
export const setPatientProfile = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${baseURL}/api/appointmentPatientProfileInfo/create`,
      formData,
      {
        headers: getAuthHeaders(),
      }
    );
    dispatch({ type: PATIENT_PROFILE_CREATED, payload: res.data });
  } catch (err) {
    if (err.response) console.error('❌ Backend Error:', err.response.data);
    else if (err.request) console.error('❌ No response:', err.request);
    else console.error('❌ Axios Error:', err.message);
  }
};

// ✅ Get All Patient Profiles
export const getAllPatientProfiles = () => async (dispatch) => {
  try {
    const res = await axios.post(
      `${baseURL}/api/appointmentPatientProfileInfo/getall`,
      {},
      {
        headers: getAuthHeaders(),
      }
    );

    const profiles = Array.isArray(res.data?.data) ? res.data.data : [];

    dispatch({
      type: GET_ALL_PATIENT_PROFILES_SUCCESS,
      payload: profiles,
    });
  } catch (error) {
    console.error('❌ Failed to fetch all patient profiles:', error);
    dispatch({
      type: GET_ALL_PATIENT_PROFILES_FAIL,
      payload: [],
    });
  }
};

// ✅ Get Patient Profile By PatientID
export const getOnePatientProfile = (patientID) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${baseURL}/api/appointmentPatientProfileInfo/byid`,
      { PatientID: patientID },
      {
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json',
        },
      }
    );

    const profile = Array.isArray(res.data?.data) && res.data.data.length > 0
      ? res.data.data[0]
      : null;

    dispatch({ type: GET_ONE_PATIENT_PROFILE, payload: profile });
  } catch (err) {
    console.error('❌ Error fetching patient profile by ID:', err);
  }
};

// ✅ Update Patient Profile
export const updatePatientProfile = (formData) => async (dispatch) => {
  try {
    const res = await axios.patch(
      `${baseURL}/api/appointmentPatientProfileInfo/update`,
      formData,
      {
        headers: getAuthHeaders(),
      }
    );

    dispatch({ type: PATIENT_PROFILE_UPDATED, payload: res.data });
  } catch (err) {
    if (err.response) console.error('❌ Update Backend Error:', err.response.data);
    else if (err.request) console.error('❌ No response:', err.request);
    else console.error('❌ Axios Error:', err.message);
  }
};
